import * as React from 'react';

import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';
import { ILocalization } from '@shared-ui/localization-context';

import { MultiItemStore } from 'stores/multi-item-store';

import { CustomerNotifications } from 'components/common/customer-notifications';
import { MitHeader } from 'components/multi-item/multi-item-header';

interface PropertySummaryHeaderProps {
  classes?: string;
  l10n?: ILocalization;
  multiItem?: MultiItemStore;
  regionId?: string;
  startDate?: string;
  endDate?: string;
}

export const PropertySummaryHeader: React.FunctionComponent<PropertySummaryHeaderProps> = ({ classes, regionId, startDate, endDate }) => (
  <div className={classes}>
    <MitHeader />
    <CustomerNotifications
      location={CustomerNotificationLocation.AFTER_HEADER}
      regionId={regionId}
      startDate={startDate}
      endDate={endDate}
    />
  </div>
);
PropertySummaryHeader.displayName = 'PropertySummaryHeader';
